export default function(property,  key = 'id', filters = {}, url = undefined, model = undefined) {
  if(typeof model === 'undefined') {
    model = property
  }

  return {
    data() {
      return {
        [property] : [],
        loading: true
      }
    },
    props: {
      ...filters,
      hiddenColumns: {
        type: Array,
        required: false,
        default: () => ([])
      },
      query: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    computed: {
      table$hiddenColumns() {
        return new Set(this.hiddenColumns)
      },
      table$filters() {
        var result = {}
        _.forEach(filters, (filter, name) => {
          var value = this[name]
          var defaultValue = typeof filter.default === 'function' ? filter.default() : filter.default

          if(value !== defaultValue) {
            result[name] = value
          }
        })

        return result
      }
    },
    watch: {
      query: {
        immediate: true,
        handler(query) {
          if(typeof this.rows !== 'undefined') {
            this.loading = false
            return
          }

          this.loading = query
          if(query === false) {
            return
          }

          this.table$load()
        }
      },
      loading(loading) {
        this.$emit('update:query', loading)
      }
    },
    mounted() {
      this.$root.$on(`${model}-updated`, this.table$updated.bind(this))
    },
    methods: {
      table$updated(data) {
        if(typeof data[model] === 'undefined') {
          this.table$handleError(`A válasz nem tartalmazott '${model}' nevű attribútumot!`)
        }

        var models = data[model]

        _.forEach(models, row  => {
          this[property] = _.filter(this[property], currentRow => currentRow[key] !== row[key])

          if(this.table$applyFilters(row)) {
            this[property].push(row)
          }
        })
      },
      table$handleError(msg) {
        if(this.handleError !== 'function') {
          this.handleError(msg)
        } else {
          console.error(msg)
        }
      },
      table$handleErrors(err) {
        if(this.handleErrors === 'function') {
          this.handleErrors(err)
        } else {
          console.error(err)
        }
      },
      table$load() {
        this.loading = true
        this[property] = []

        this.$http.get(this.$url(url), {params: this.table$filters})
          .then(({data}) => {
            if(typeof data[model] !== 'undefined') {
              this[property] = data[model]
            } else {
              this.table$handleError(`A válasz nem tartalmazott '${model}' nevű attribútumot!`)
            }
          })
          .catch(this.table$handleErrors)
          .finally(() => this.loading = false)
      },
      table$applyFilters(row) {
        return _.reduce(filters, (filtered, filter, name) => {
          if(typeof filter.key === 'undefined') {
            return filtered
          }

          var defaultValue = typeof filter.default === 'function' ? filter.default() : filter.default
          if(this[name] === defaultValue) {
            return filtered
          }

          return filtered && row[filter.key] === this[name]
        }, true)
      }
    }
  }
}